import { SelectOption } from '@consigli/facade';
import { Blob } from '@consigli/types';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';

import { TreeNode } from '@/pages/insight/folders/util/document-list-to-tree';

export const FileTreeContext = createContext<{
  activeFolderFiles: Blob[];
  setActiveFolderFiles: Dispatch<SetStateAction<Blob[]>>;
  tree: {
    children: Map<string, TreeNode>;
  };
  setTree: Dispatch<
    SetStateAction<{
      children: Map<string, TreeNode>;
    }>
  >;
  activeFolderId: string;
  setActiveFolderId: Dispatch<SetStateAction<string>>;
  summaryCount: Record<string, number> | undefined;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  selectedDocumentTypes: SelectOption[];
  setSelectedDocumentTypes: Dispatch<SetStateAction<SelectOption[]>>;
  selectedBlobIds: SelectOption[];
  setSelectedBlobIds: Dispatch<SetStateAction<SelectOption[]>>;
  searchContent: string;
  setSearchContent: Dispatch<SetStateAction<string>>;
  search: string;
  setSearch: Dispatch<SetStateAction<string>>;
  selectedCard: string;
  setSelectedCard: Dispatch<SetStateAction<string>>;
  labelsReused: boolean;
  setLabelsReused: Dispatch<SetStateAction<boolean>>;
} | null>(null);

export const useFileTreeContext = () => {
  const ctx = useContext(FileTreeContext);
  if (ctx === null) {
    throw new Error(`Called useFileTreeContext without Provider in tree`);
  }
  return ctx;
};
